import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/serviceLocation-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ServiceLocationForm';
import { IServiceLocation } from 'src/types/service-locations';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    serviceLocation: IServiceLocation | null;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: number;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export type OwnProps = RouteComponentProps<RouteParams>;

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ServiceLocationEditScreen extends React.Component<Props> {
    componentDidMount() {
        const {
            match: {
                params: { id },
            },
            getData,
            serviceLocation,
        } = this.props;

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!serviceLocation || serviceLocation.id !== id) {
            getData(`${id}`);
        }
    }

    public render(): ReactNode {
        const { serviceLocation, inProgress } = this.props;

        if (!serviceLocation || inProgress) {
            return <Loader />;
        }
        return (
            <AdminLayout>
                <Breadcrumbs
                    items={[
                        { name: 'SERVICE LOCATIONS', path: routes.SERVICE_LOCATIONS_LIST },
                        { name: `EDIT SERVICE`, path: '' },
                    ]}
                />
                <div className={classNames(styles.editWrapFrom)}>
                    <Form
                        initialValues={{
                            ...serviceLocation,
                            isPrivate: serviceLocation.isPrivate ? true : false,
                            description: serviceLocation.description ? serviceLocation.description : ' ',
                        }}
                    />
                </div>
            </AdminLayout>
        );
    }
}

export default ServiceLocationEditScreen;
